import { render, staticRenderFns } from "./EditResponseSet.vue?vue&type=template&id=0b72d115&"
import script from "./EditResponseSet.vue?vue&type=script&lang=js&"
export * from "./EditResponseSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports